import { SafetyRatingFeedbackComponent } from './components/safety-rating-feedback/safety-rating-feedback.component';
import { AnalyticsContainerComponent } from './analytics-container.component';
import { AnalyticsComponent } from './components/analytics/analytics.component'
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CrewRatingsDetailComponent } from './components/crew-ratings-detail/crew-ratings-detail.component';


const routes: Routes = [
  {
    path: '',
    component: AnalyticsContainerComponent,
    children: [
      {
        path: '',
        component: AnalyticsComponent
      },
      {
        path: 'crew-ratings-detail/:crewId',
        component: CrewRatingsDetailComponent
      },
      {
        path: 'safety-rating-feedback/:ratingMasterId',
        component: SafetyRatingFeedbackComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnalyticsRoutingModule { }
